import React, { useEffect, useState } from "react";
import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";
import { Loading } from "components/common";
import { ENROLLMENT_STATUS } from "utils/constants";
import { track } from "utils";
import CreditMonitoring from "./CreditMonitoring/CreditMonitoring";
import { CreditMonitoringVerification } from "./CreditMonitoring/Verification";

// TODO check this query
const USER_CREDIT_SCORE_AND_SUMMARY_QUERY = gql`
  query UserCreditScore($order: String!, $limit: Int!) {
    getUserCreditScore(order: $order, limit: $limit) {
      credit_scores {
        credit_score
        date_pulled_at
        credit_scoring_model
        credit_summary {
          credit_utilization
          oldest_credit_opened_date
          credit_checks
          total_opened_accounts
        }
      }
      details {
        status
        transunion {
          lockedAt
        }
      }
    }
  }
`;

const COMPONENTS = {
  [ENROLLMENT_STATUS.ELIGIBLE]: CreditMonitoring,
  [ENROLLMENT_STATUS.ENROLLED]: CreditMonitoring,
  [ENROLLMENT_STATUS.WAITING]: CreditMonitoringVerification,
  [ENROLLMENT_STATUS.TERMINATED]: CreditMonitoring,
  [ENROLLMENT_STATUS.LOCKED]: CreditMonitoring,
};

const CreditMonitoringDashboard = () => {
  const { data, loading } = useQuery(USER_CREDIT_SCORE_AND_SUMMARY_QUERY, {
    variables: { limit: 1, order: "desc" },
  });
  const creditScoreSummary = data?.getUserCreditScore;
  const [status, setStatus] = useState("");

  const lockedAt = creditScoreSummary?.details?.transunion?.lockedAt || null;

  useEffect(() => {
    if (data) {
      setStatus(data.getUserCreditScore?.details?.status);
    }
  }, [data]);

  useEffect(() => {
    track("CREDIT_MONITORING_DASHBOARD_VIEW");
  }, []);

  const renderComponent = () => {
    const Component = COMPONENTS[status];
    if (Component) {
      return (
        <Component
          creditScoreSummary={creditScoreSummary}
          setStatus={setStatus}
          status={status}
          lockedAt={lockedAt ? new Date(lockedAt) : null}
        />
      );
    }
    return null;
  };

  return (
    <>
      {loading && <Loading />}
      {renderComponent()}
    </>
  );
};

export default CreditMonitoringDashboard;
